<template>
    <div class="container">
        <div class="header">
            <div class="header-left">
                <el-button type="primary" @click="handleClick('insert')">新增</el-button>
                <el-button type="primary" @click="loadData(1)">刷新</el-button>
                <el-button type="primary" @click="downloadOpen()" :disabled="selectRows.length > 0 ? false : true">一键下载选中项目</el-button>
            </div>
            <div class="header-right">
                <el-select v-model="filterParams.admin_id" placeholder="请选择代卖人" @change="loadData(1)"
                    class="header-input">
                    <el-option :label="'不限代卖人'" :value="''"></el-option>
                    <el-option v-for="item in admins" :key="item.adminId" :label="item.adminName"
                        :value="item.adminId"></el-option>
                </el-select>
                <el-select v-model="filterParams.resale_type" placeholder="请选择代卖类型" @change="loadData(1)"
                    class="header-input">
                    <el-option :label="'不限代卖类型'" :value="''"></el-option>
                    <el-option :label="item.label" :value="item.value" v-for="item in resaleTypeArray"></el-option>
                </el-select>
                <el-input v-model="filterParams.product_name" placeholder="请输入钱币名称" class="header-input"
                    @change="loadData(1)"></el-input>
                <el-input v-model="filterParams.product_appraisal" placeholder="请输入评级编码" class="header-input"
                    @change="loadData(1)"></el-input>
                <el-button type="primary" @click="loadData(1)">搜索</el-button>
                <el-button type="primary" @click="openDeleteByAdminId()" v-if="filterParams.admin_id">一键删除</el-button>
            </div>
        </div>
        <el-table :data="records" border style="width: 100%" @selection-change="selectRowsChange">
            <!-- <el-table-column label="序号" width="70">
                <template slot-scope="scope">
                    {{ scope.$index + 1 }}
                </template>
            </el-table-column> -->
            <el-table-column type="selection" width="40"></el-table-column>
            <el-table-column prop="productName" label="代卖钱币" width="250">
                <template slot-scope="scope">
                    <el-popover placement="top-start" trigger="hover">
                        <el-image style="width: 300px; height: 300px;" :src="getFirstImageSrc(scope.row.productImages)"
                            fit="cover"></el-image>
                        <el-button type="text" slot="reference">{{ scope.row.productName }}</el-button>
                    </el-popover>
                </template>
            </el-table-column>
            <el-table-column prop="customerName" label="出品人"></el-table-column>
            <el-table-column prop="productAppraisal" label="评级编码"></el-table-column>
            <el-table-column prop="productPrize" label="钱币价格"></el-table-column>
            <el-table-column prop="resaleType" label="代卖类型">
                <template slot-scope="scope">
                    <el-popover placement="top-start" trigger="hover" @show="popoverShow(scope.row.productId)">
                        <div>
                            <div v-for="item in popovers">{{ item.adminName }}：{{ getResaleTypeName(item.resaleType) }}
                            </div>
                        </div>
                        <el-button type="text" slot="reference">{{ getResaleTypeName(scope.row.resaleType)
                            }}</el-button>
                    </el-popover>
                </template>
            </el-table-column>
            <el-table-column label="创建时间">
                <template slot-scope="scope">
                    {{ convertToDate(scope.row.resaleDate) }}
                </template>
            </el-table-column>
            <el-table-column prop="adminName" label="代卖人"></el-table-column>
            <el-table-column prop="addressName" label="库存地"></el-table-column>
            <el-table-column prop="productImages" label="钱币底图">
                <template slot-scope="scope">
                    <div style="position: relative; width: 50px; height: 50px;">
                        <el-image style="width: 50px; height: 50px;" :src="getFirstImageSrc(scope.row.productImages)"
                            fit="cover" :preview-src-list="getImageSrcList(scope.row.productImages)"></el-image>
                        <div v-if="scope.row.productImages.split(',').length > 1"
                            style="position: absolute; background-color: #FF0000; top: 0px; right: 0px; z-index: 99; width: 16px; height: 16px; line-height: 16px; text-align: center; color: #FFFFFF; font-size: 10px; border-radius: 50%;">
                            {{ scope.row.productImages.split(",").length }}</div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="90">
                <template slot-scope="scope">
                    <!-- <el-button
                        @click="downloadAllImages(getImageSrcList(scope.row.productImages), scope.row.productAppraisal)"
                        type="text" size="small">批量下载</el-button> -->
                    <el-button @click="handleClick('delete', scope.row)" type="text" size="small">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div v-if="total > 0" class="page-wrapper">
            <el-pagination @size-change="sizeChange" @current-change="currentChange" :current-page="current"
                :page-sizes="[10, 20, 30, 40, 100, 500]" :page-size="size" layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </div>
        <el-dialog :title="getModalTitle()" :visible.sync="isHandle" width="30%" :close-on-click-modal="false">
            <div v-if="handle == 'delete'">您确认要删除吗？删除后将不可恢复！</div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="isHandle = false">取 消</el-button>
                <el-button type="primary" @click="handleSubmit()">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog title="一键删除" :visible.sync="isDeleteByAdmin" width="30%" :close-on-click-modal="false">
            <div>您确认要删除当前代卖人的所有代卖信息吗？一旦删除将无法恢复</div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="isDeleteByAdmin = false">取 消</el-button>
                <el-button type="primary" @click="confirmDeleteByAdminId()">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import verifyMixin from "@/mixins/verify-mixin.js"
import listMixin from "@/mixins/list-mixin.js"
import imageMixin from "@/mixins/image-mixin.js"
import enumMixin from "@/mixins/enum-mixin.js"
import { API, doGet, doPost } from "@/api/api"
import axios from "axios"

export default {
    mixins: [verifyMixin, listMixin, imageMixin, enumMixin],
    data: function () {
        return {
            downloadForm: {
                downloadName: "",
                downloadProductIds: ""
            },
            isDeleteByAdmin: false,
            popovers: [],
            admins: []
        }
    },
    methods: {
        downloadOpen: function () {
            if (this.selectRows == null || this.selectRows.length == 0) {
                this.$message.warning("未选中数据");
                return;
            }
            let ids = "";
            for (let i = 0; i < this.selectRows.length; i++) {
                if (i > 0) {
                    ids += ",";
                }
                ids += this.selectRows[i].productId;
            }
            this.downloadForm.downloadProductIds = ids;
            this.$prompt('任务名称', '创建下载任务', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputPattern: /\S/,
                inputErrorMessage: '任务名称不能为空'
            }).then(async ({ value }) => {
                this.downloadForm.downloadName = value;
                let resultObj = await doPost(API.REST.DOWNLOAD, this.downloadForm);
                if (resultObj.errorCode == 0) {
                    this.$message.success("创建下载任务成功");
                }
                else {
                    this.$message.warning("创建下载任务失败");
                }
            }).catch(() => { })
        },
        openDeleteByAdminId: function() {
            this.isDeleteByAdmin = true;
        },
        confirmDeleteByAdminId: async function() {
            let res = await doGet(API.DELETE_RESALE_BY_SALERID, { salerId: this.filterParams.admin_id });
            this.showResult(res);
            this.isDeleteByAdmin = false;
            this.loadData(1);
        },
        prizeShow: function() {
            this.prize.show = true;
        },
        popoverShow: async function (productId) {
            this.popovers = [];
            let res = await doGet(API.ALL.RESALE, { product_id: productId });
            this.popovers = res.records;
        },
        reloadData: async function () {
            this.admins = await doGet(API.ALL.ADMIN);
            this.$forceUpdate();
        },
        downloadSingleImage: function (url, name) {
            axios({
                url,
                method: "GET",
                responseType: 'blob'
            }).then(res => {
                const blob = new Blob([res.data]);
                const url = URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = name;
                a.click();
                URL.revokeObjectURL(url);
            });
        },
        downloadAllImages: function (urls, code) {
            this.$message.warning(code + "正在批量下载，请稍后...");
            for (let i = 0; i < urls.length; i++) {
                if (!code) {
                    code = (new Date()).getTime();
                }
                this.downloadSingleImage(urls[i], code + "-" + (i + 1) + ".jpg");
            }
        },
        downloadAllImagesByPage: function (urls, code) {
            this.$message.warning("正在批量下载，时间会较长，请耐心等待");
            for (let i = 0; i < this.records.length; i++) {
                let code = this.records[i].productAppraisal;
                let urls = this.getImageSrcList(this.records[i].productImages);
                for (let j = 0; j < urls.length; j++) {
                    if (!code) {
                        code = (new Date()).getTime();
                    }
                    this.downloadSingleImage(urls[j], code + "-" + (j + 1) + ".jpg");
                }
            }
        }
    },
    created: async function () {
        this.initialUrl = API.ALL.RESALE;
        this.tag = "RESALE";
    }
}
</script>
<style scoped lang="less">
@import "@/assets/style/list-style.less";
</style>